import { Injectable } from '@angular/core';
import {
  INGXLoggerConfig,
  INGXLoggerMetadata,
  NGXLoggerWriterService,
  NGXLogger,
} from 'ngx-logger';
import { LogsRepository } from '../store/logs.repository';

@Injectable()
export class ElfJsWriterStoreService extends NGXLoggerWriterService {
  constructor(private loggerRepository: LogsRepository) {
    super('platformid');
  }
  private uniqueId() {
    // desired length of Id
    var idStrLen = 32;
    // always start with a letter -- base 36 makes for a nice shortcut
    var idStr = (Math.floor(Math.random() * 25) + 10).toString(36) + '_';
    // add a timestamp in milliseconds (base 36 again) as the base
    idStr += new Date().getTime().toString(36) + '_';
    // similar to above, complete the Id using random, alphanumeric characters
    do {
      idStr += Math.floor(Math.random() * 35).toString(36);
    } while (idStr.length < idStrLen);

    return idStr;
  }

  //NGXLogger

  /** Write the content sent to the log function to the sessionStorage */
  override writeMessage(
    metadata: INGXLoggerMetadata,
    config: INGXLoggerConfig
  ): void {
    //TODO: add log to store

    this.loggerRepository.insertLog(
      Object.assign({}, metadata, { id: this.uniqueId() })
    );
    console.log(metadata.message);
  }
}
